module.exports = __webpack_public_path__ + "static/media/ValeVeiculos-alpha.3f8bdad6.png";